// HW-CUSTOM: Ergänzende Produkte – Add-to-Cart mit Mengenfeld (VPE-Schritte) + nativer Cart-Notification-Update
document.addEventListener('DOMContentLoaded', function() {

  var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  document.querySelectorAll('.complementary-add-button').forEach(function(button) {
    button.addEventListener('click', function() {
      if (this.disabled) return;
      this.disabled = true;

      var currentButton = this;
      var variantId = this.dataset.variantId;
      var container = this.closest('.complementary-product');
      var quantityInput = container ? container.querySelector('.quantity__input') : null;
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      if (!quantity || quantity < 1) quantity = 1;

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (data.status) {
          console.error(data.description || data.message);
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'complementary-products', cartData: data });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        }
      })
      .catch(function(error) { console.error(error); })
      .finally(function() { currentButton.disabled = false; });
    });
  });

});
// /HW-CUSTOM